import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { message } from "antd";
import axios from "axios";
import PageHeader from "../../Routes/PageHeader";
import { API, Headers } from "../../Config";
import LoadingBox from "../../Components/LoadingBox";
import DataTable from "./DataTable";
import FormModalContra from "./FormModalContra";

const ContraVoucher = () => {
  const { page_mode } = useParams();
  const [loading, setLoading] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [form, setForm] = useState(false);
  const [mode, setMode] = useState("post");
  const [head, setHead] = useState("");
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [item, setItem] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [columnsVisible, setColumnsVisible] = useState({
    page: "Contra Voucher",
    short: "CV",
    accounts: true,
  });

  useEffect(() => {
    console.log("page_mode:", page_mode);
    console.log("head:", head);
    if (page_mode === "CV") {
      setHead("");
      loaddata(page, take);
      AccountsDropdown();
    } else {
      message.error("Invalid page mode");
      setHead("");
      setLoading(false);
    }
  }, [page, take, page_mode]);

  const loaddata = (p, t) => {
    axios
      .get(`${API.BASR_URL}${API.CONTRA_VOUCHER_LIST}?page=${p}&take=${t}`, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          const { data, meta } = response.data;
          setData(Array.isArray(data) ? data : []);
          setMeta(meta || {});
          message.success("Data loaded successfully");
        } else {
          message.error("Failed to load data");
        }
        setLoading(false);
        setIndicator(false);
      })
      .catch(function (error) {
        console.error("Error loading data:", error);
        message.error("Oops. Something went wrong");
        setData([]);
        setMeta({});
        setIndicator(false);
        setLoading(false);
      });
  };

  const AccountsDropdown = () => {
    axios
      .get(`${API.BASR_URL}${API.CHART_OF_ACCOUNTS_LIST}/child_accounts`, {
        headers: Headers(),
      })
      .then(function (res) {
        if (res.status === 200) {
          setAccounts(Array.isArray(res.data) ? res.data : []);
        } else {
          message.error("Failed to load accounts");
        }
      })
      .catch(function (error) {
        console.error("Error loading accounts:", error);
        message.error("Accounts dropdown failed");
        setAccounts([]);
      });
  };

  const pagination = (page, take) => {
    window.scrollTo(0, 0);
    setIndicator(true);
    setPage(page);
    setTake(take);
  };

  const reload = () => {
    loaddata(page, take);
    setMode("post");
    setItem({});
    setForm(false);
    setLoading(true); // Set loading to true when reloading
    setTimeout(() => {
      setLoading(false); // Simulate loading completion after 1 second
    }, 50);
  };

  const AddItem = () => {
    console.log("AddItem clicked: Opening modal");
    setMode("post");
    setItem({});
    setForm(true);
    setLoading(true); // Set loading to true when opening the modal
    setTimeout(() => {
      setLoading(false); // Simulate loading completion after 1 second
    }, 50);
  };

  const UpdateItem = (item) => {
    console.log("UpdateItem:", item);
    setMode("put");
    setItem(item);
    setForm(true);
    setLoading(true); // Set loading to true when opening the modal
    setTimeout(() => {
      setLoading(false); // Simulate loading completion after 1 second
    }, 50);
  };

  const DeleteItem = (item) => {
    setIndicator(true);
    axios
      .delete(`${API.BASR_URL}${API.CONTRA_VOUCHER_ACTIONS}/${item.id}`, {
        headers: Headers(),
      })
      .then(function (response) {
        setIndicator(false);
        message.success("Deleted Successfully");
        reload();
      })
      .catch(function (error) {
        setIndicator(false);
        message.error("Oops. Something went wrong");
        console.error("Error deleting item:", error);
      });
  };

  const saveContra = (values, ledgerFrom, ledgerTo) => {
    setIndicator(true);
    const obj = {
      ledger_from: ledgerFrom || "",
      description: values.description || "",
      ledger_to: ledgerTo || "",
      voucher_date: values.voucher_date ? values.voucher_date : "",
      amount: Number(values.amount) || 0,
    };

    axios({
      method: "post",
      url: `${API.BASR_URL}${API.CONTRA_VOUCHER_ACTIONS}`,
      headers: {
        ...Headers(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: obj,
    })
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          message.success("Created Successfully");
          reload();
        }
      })
      .catch((error) => {
        message.error("Oops. Something went wrong");
        console.error("Error creating contra:", error);
      })
      .finally(() => {
        setIndicator(false);
      });
  };

  const updateContra = (itemId, values, ledgerFrom, ledgerTo) => {
    setIndicator(true);
    const obj = {
      ledger_from: ledgerFrom || "",
      description: values.description || "",
      ledger_to: ledgerTo || "",
      voucher_date: values.voucher_date
        ? values.voucher_date.format("YYYY-MM-DD")
        : "",
      amount: Number(values.amount) || 0,
    };

    axios({
      method: "put",
      url: `${API.BASR_URL}${API.CONTRA_VOUCHER_ACTIONS}/${itemId}`,
      headers: {
        ...Headers(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: obj,
    })
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          message.success("Updated Successfully");
          reload();
        }
      })
      .catch((error) => {
        message.error("Oops. Something went wrong");
        console.error("Error updating contra:", error);
      })
      .finally(() => {
        setIndicator(false);
      });
  };

  return (
    <div>
      <PageHeader
        PageName={head}
        breadScrum={`Admin / ${columnsVisible.page}`}
        RightButton={` New ${columnsVisible.page}`}
        RightClcik={AddItem}
        loaderculos={indicator}
      />
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <DataTable
            columnsVisible={columnsVisible}
            meta={meta}
            data={data}
            update={UpdateItem}
            delete={DeleteItem}
            PageOnchange={pagination}
          />
          <FormModalContra
            page_mode={page_mode}
            setLoading={setLoading}
            accounts={accounts}
            head={head}
            item={item}
            mode={mode}
            visible={form}
            columnsVisible={columnsVisible}
            onSave={saveContra}
            onUpdate={updateContra}
            onChange={reload}
            onClose={() => {
              console.log("Closing modal");
              setForm(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ContraVoucher;
